import { Text } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";

export const Nom = (props) => {
    const { index, disabled } = props;

    return (
        <div className={'row justify-content-center'}>
            <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                <Field
                    name={`DemandeTarif[ListePersonnes][${index}][Nom]`}
                    label={index === 1 ? getTranslation('lastNameSubscriptor') : getTranslation('lastName') }
                    component={Text}
                    type={'text'}
                    typeFormat={'text'}
                    required
                    disabled={disabled}
                    autocomplete="family-name"
                />
            </div>
        </div>
    );
};
